import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useParams, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import "../Forms/InvoiceForm.css";
// import "./Forms.css";
import Select from "react-select"; // Import react-select
import axiosInstance from "../axiosinstance";
import { Snackbar, Alert as MuiAlert } from "@mui/material"; // Import MuiAlert as Alert
import SubsidiaryModal from "../Popup/SubsidaryModal";
function formatToYYYYMMDD(dob) {
  if (!dob) return null;
  const [day, month, year] = dob.split("-");
  return `${year}-${month}-${day}`;
}

function parseGMTDateToDDMMYYYY(gmtString) {
  if (!gmtString) return "";

  // Convert GMT string → Date object
  const date = new Date(gmtString);
  if (isNaN(date.getTime())) return ""; // invalid date

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

export default function EditClientManagement({ isSidebarExpanded }) {
  const companyTypes = [
    { value: "individual", label: "Individual / Proprietorship" },
    { value: "huf", label: "HUF" },
    { value: "partnership_firm", label: "Partnership Firm" },
    { value: "private_ltd", label: "Private Limited Company" },
    { value: "limited_company", label: "Limited Company" },
    { value: "llp", label: "Limited Liability Partnership" },
    { value: "aop", label: "Association of Persons" },
    { value: "trust", label: "Trust" },
  ];
  const [selectedCompanyType, setSelectedCompanyType] = useState(""); // Initialize as empty string or default value
  const [clientType, setClientType] = useState("");
  const [familyGroups, setFamilyGroups] = useState([]);
  const [selectedFamilyId, setSelectedFamilyId] = useState("");
  const [familyGroupsLoading, setFamilyGroupsLoading] = useState(false);
  const [familyGroupsError, setFamilyGroupsError] = useState("");
  const [isCreateFamilyModalOpen, setIsCreateFamilyModalOpen] = useState(false);
  const [createFamilyForm, setCreateFamilyForm] = useState({
    family_name: "",
    contact_name: "",
    phone_number: "",
    email: "",
  });
  const [createFamilyErrors, setCreateFamilyErrors] = useState({});
  const [isCreatingFamily, setIsCreatingFamily] = useState(false);
  const [selectedSubsidaryId, setSelectedSubsidaryId] = useState(null);
  const { client_id } = useParams();
  const [file_number, setFileNumber] = useState("");
  const [selectedOptionBalance, setSelectedOptionBalance] = useState(null);
  const [openingAmount, setopeningAmount] = useState("");

  const [contactPersons, setContactPersons] = useState([
    { name: "", email: "", phone: "" },
  ]);
  const [subsidaries, setSubsidaries] = useState([]);
  const [selectedSubsidary, setSelectedSubsidary] = useState("");
  const [paymentTerm, setPaymentTerm] = useState("");
  const [dob, setDob] = useState("");
  const [pan, setPan] = useState("");
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    postalCode: "",
  });
  const [isSubsidiaryModalOpen, setIsSubsidiaryModalOpen] = useState(false);
  const [clientName, setClientName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [errors, setErrors] = useState({
    clientName: "",
    companyName: "",
    email: "",
    phone: "",
    address: "",
    paymentTerm: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();
  const createFamilyFirstInputRef = useRef();
  const menuPortalTarget = typeof window !== "undefined" ? document.body : null;
  const familyModalPortalTarget =
    typeof document !== "undefined" ? document.body : null;
  const isPrimaryLocked =
    clientType === "family group" && Boolean(selectedFamilyId);

  const fetchFamilyGroups = async (force = false) => {
    if (!force && (familyGroupsLoading || familyGroups.length > 0)) return;
    try {
      setFamilyGroupsLoading(true);
      setFamilyGroupsError("");
      const response = await axiosInstance.get("/api/family_group");
      const families = Array.isArray(response.data.data)
        ? response.data.data
        : [];
      setFamilyGroups(families);
    } catch (error) {
      console.error("Error fetching family groups:", error.message);
      setFamilyGroupsError("Failed to load family groups");
    } finally {
      setFamilyGroupsLoading(false);
    }
  };
  const handleSubsidiaryCreated = (newSubsidiary, message) => {
    console.log("New Subsidiary Created:", newSubsidiary); // Debug log

    setSubsidaries((prev) => [...prev, newSubsidiary]);
    setSelectedSubsidary(newSubsidiary.label); // auto-select
    setSelectedSubsidaryId(newSubsidiary.value);
    setErrors((prev) => ({ ...prev, selectedSubsidary: "" }));
    setSnackbarSeverity("success");
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };
  const mapFamilyContactToPrimary = (family) => {
    if (!family) return;
    setContactPersons((prevContacts) => {
      const nextContacts =
        prevContacts && prevContacts.length > 0
          ? [...prevContacts]
          : [{ name: "", email: "", phone: "", isPrimary: true }];

      nextContacts[0] = {
        ...nextContacts[0],
        name: family.contact_name || "",
        email: family.email || "",
        phone: (family.phone_number || "").toString(),
        isPrimary: true,
      };

      return nextContacts.map((contact, index) => ({
        ...contact,
        isPrimary: index === 0,
      }));
    });
  };

  const resetCreateFamilyModal = () => {
    setCreateFamilyForm({
      family_name: "",
      contact_name: "",
      phone_number: "",
      email: "",
    });
    setCreateFamilyErrors({});
    setIsCreatingFamily(false);
  };

  const openCreateFamilyModal = () => {
    document.activeElement?.blur?.();
    resetCreateFamilyModal();
    setIsCreateFamilyModalOpen(true);
  };

  const closeCreateFamilyModal = () => {
    setIsCreateFamilyModalOpen(false);
    resetCreateFamilyModal();
  };

  const validateCreateFamilyForm = () => {
    const nextErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!createFamilyForm.family_name.trim()) {
      nextErrors.family_name = "Family Name is required";
    }
    if (!createFamilyForm.contact_name.trim()) {
      nextErrors.contact_name = "Contact Name is required";
    }
    if (!createFamilyForm.phone_number.trim()) {
      nextErrors.phone_number = "Phone Number is required";
    } else if (!/^\d{10}$/.test(createFamilyForm.phone_number.trim())) {
      nextErrors.phone_number = "Phone Number must be 10 digits";
    }
    if (!createFamilyForm.email.trim()) {
      nextErrors.email = "Email Id is required";
    } else if (!emailRegex.test(createFamilyForm.email.trim())) {
      nextErrors.email = "Enter a valid email address";
    }

    setCreateFamilyErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleCreateFamily = async () => {
    if (isCreatingFamily || !validateCreateFamilyForm()) return;

    const payload = {
      family_name: createFamilyForm.family_name.trim(),
      contact_name: createFamilyForm.contact_name.trim(),
      phone_number: createFamilyForm.phone_number.trim(),
      email: createFamilyForm.email.trim(),
    };

    try {
      setIsCreatingFamily(true);
      const response = await axiosInstance.post(
        "/api/create_family_group",
        payload,
      );
      const returnedFamilyId =
        response.data?.family_id ||
        response.data?.data?.family_id ||
        response.data?.result?.family_id ||
        "";

      if (!returnedFamilyId) {
        throw new Error("Family ID missing in response");
      }

      const createdFamily = {
        family_id: returnedFamilyId,
        family_name: payload.family_name,
        contact_name: payload.contact_name,
        phone_number: payload.phone_number,
        email: payload.email,
      };

      setFamilyGroups((prev) => {
        const filtered = prev.filter(
          (family) => family.family_id !== createdFamily.family_id,
        );
        return [...filtered, createdFamily];
      });

      setSelectedFamilyId(createdFamily.family_id);
      mapFamilyContactToPrimary(createdFamily);
      setSnackbarSeverity("success");
      setSnackbarMessage(
        response.data?.message || "Family Group added successfully",
      );
      setSnackbarOpen(true);
      closeCreateFamilyModal();
    } catch (error) {
      console.error("Error creating family group:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to create Family Group",
      );
      setSnackbarOpen(true);
    } finally {
      setIsCreatingFamily(false);
    }
  };

  const fetchSubsidaries = async (status = "Active") => {
    try {
      const response = await axiosInstance.get(
        `/api/get_all_subsidiary?page_status=${status}`,
      );

      if (response.status === 200) {
        const firms = response.data.data;

        const firmNames = firms.map((company) => ({
          label: company.Subsidiary_name, // Display name
          value: company.subsidiary_id, // Unique identifier
          tag_name: company.tag_name, // Include tag_name for display
        }));

        setSubsidaries(firmNames);
      } else {
        console.error("Failed to fetch subsidiaries");
      }
    } catch (error) {
      console.error("Error fetching subsidiary data:", error.message);
    }
  };

  useEffect(() => {
    fetchSubsidaries();
  }, []); // Runs once on component mount

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/get_client_by_id/${client_id}`,
        );

        if (response.status === 200 && response.data?.result) {
          const data = response.data.result;

          setSelectedSubsidaryId(data.subsidiary_id || "");
          setContactPersons(
            data.contact_list?.map((contact) => ({
              contactId: contact.contact_id, // Include contact_id
              name: contact.contact_name || "",
              email: contact.contact_email || "",
              phone: contact.phone_number || "",
              isPrimary:
                contact.is_primary !== null ? contact.is_primary : false,
            })) || [],
          );
          setSelectedCompanyType(data.company_type || "");
          setFileNumber(data.file_number);
          setSelectedOptionBalance(data.balance_type);
          setopeningAmount(data.opening_balance);
          setDob(data.dob ? parseGMTDateToDDMMYYYY(data.dob) : "");
          setPan(data.pan_number || "");
          setPaymentTerm(data.payment_terms || "");
          setAddress({
            street: data.office_number || "",
            city: data.landmark || "",
            state: data.area || "",
            postalCode: data.pin || "",
          });
          setClientName(data.client_name?.trim() || "");
          setCompanyName(data.clients_company_name?.trim() || "");
          // const normalizedClientType = (data.client_type || "").toLowerCase();
          // setClientType(
          //   normalizedClientType === "individual" ||
          //     normalizedClientType === "family group"
          //     ? normalizedClientType
          //     : ""
          // );

          setClientType(data.is_family_member ? "family group" : "individual");

          setSelectedFamilyId(data.family_id || "");
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };

    fetchClientData();
  }, [client_id]); // Ensure `subsidaries` is available before matching

  useEffect(() => {
    if (clientType === "family group") {
      fetchFamilyGroups();
      return;
    }

    setSelectedFamilyId("");
    setFamilyGroupsError("");
    setIsCreateFamilyModalOpen(false);
  }, [clientType]);

  useEffect(() => {
    if (
      clientType !== "family group" ||
      !selectedFamilyId ||
      familyGroups.length === 0
    ) {
      return;
    }

    const selectedFamily = familyGroups.find(
      (family) => family.family_id === selectedFamilyId,
    );
    mapFamilyContactToPrimary(selectedFamily);
  }, [clientType, selectedFamilyId, familyGroups]);

  useEffect(() => {
    if (isCreateFamilyModalOpen) {
      createFamilyFirstInputRef.current?.focus();
    }
  }, [isCreateFamilyModalOpen]);

  useEffect(() => {
    if (!isCreateFamilyModalOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isCreateFamilyModalOpen]);

  const handleRemoveContactPerson = (index) => {
    const updatedContacts = contactPersons.filter((_, i) => i !== index);
    setContactPersons(updatedContacts);
  };

  const handleAddContactPerson = () => {
    setContactPersons([...contactPersons, { name: "", email: "", phone: "" }]);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleInputChanges = (field, value) => {
    setErrors((prev) => ({ ...prev, [field]: "" })); // Clears the specific field error
  };

  const handleAddressChange = (field, value) => {
    setAddress({ ...address, [field]: value });
  };

  const validateForm = () => {
    const newErrors = {};

    // 🔹 Contact Persons
    contactPersons.forEach((contact, index) => {
      if (!contact.name?.trim()) {
        newErrors[`name_${index}`] = "Contact name is required";
      } else if (contact.name.length > 100) {
        newErrors[`name_${index}`] = "Name must not exceed 100 characters";
      }

      if (!contact.email?.trim()) {
        newErrors[`email_${index}`] = "Email is required";
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(contact.email)
      ) {
        newErrors[`email_${index}`] = "Enter a valid email address";
      } else if (contact.email.length > 100) {
        newErrors[`email_${index}`] = "Email must not exceed 100 characters";
      }

      if (!contact.phone?.trim()) {
        newErrors[`phone_${index}`] = "Phone number is required";
      } else if (!/^\d{10}$/.test(contact.phone)) {
        newErrors[`phone_${index}`] = "Phone number must be 10 digits";
      }
    });

    // 🔹 Client Name
    if (!clientName.trim()) {
      newErrors.clientName = "Client Name is required";
    } else if (clientName.length > 100) {
      newErrors.clientName = "Client name must not exceed 100 characters";
    }

    // 🔹 Company Name
    if (!companyName.trim()) {
      newErrors.companyName = "Company/Firm Name is required";
    } else if (companyName.length > 150) {
      newErrors.companyName =
        "Company/Firm name must not exceed 150 characters";
    }

    // 🔹 Company Type
    if (!selectedCompanyType) {
      newErrors.selectedCompanyType = "Company Type is required";
    }
    if (!clientType) {
      newErrors.clientType = "Client Type is required";
    }
    if (clientType === "family group") {
      if (!selectedFamilyId) {
        newErrors.familyGroup = "Family Group is required";
      }
    }
    // 🔹 Payment Term
    if (!String(paymentTerm).trim()) {
      newErrors.paymentTerm = "Payment term is required";
    } else if (paymentTerm.length > 10) {
      newErrors.paymentTerm = "Payment term must not exceed 10 characters";
    }

    // 🔹 PAN Number
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!pan.trim()) {
      newErrors.pan = "PAN number is required";
    } else if (!panRegex.test(pan)) {
      newErrors.pan = "Invalid PAN format (e.g., ABCDE1234F)";
    }

    // 🔹 Birth Date Number
    if (!dob) {
      newErrors.dob = "Birth date is required";
    } else {
      const strictRegex = /^(\d{2})-(\d{2})-(\d{4})$/;

      if (!strictRegex.test(dob)) {
        newErrors.dob = "Invalid format. Use DD-MM-YYYY";
      } else {
        const [_, dd, mm, yyyy] = dob.match(strictRegex);

        const day = parseInt(dd, 10);
        const month = parseInt(mm, 10);
        const year = parseInt(yyyy, 10);

        // Month check
        if (month < 1 || month > 12) {
          newErrors.dob = "Invalid month. Must be between 01 and 12";
        }
        // Day check
        else if (day < 1 || day > 31) {
          newErrors.dob = "Invalid day. Must be between 01 and 31";
        } else {
          const dateObj = new Date(year, month - 1, day);

          // Check actual date validity
          if (
            dateObj.getDate() !== day ||
            dateObj.getMonth() !== month - 1 ||
            dateObj.getFullYear() !== year
          ) {
            newErrors.dob = "Invalid date";
          }

          // ❗ Strict rule: No dates <= 1900
          else if (year < 1935) {
            newErrors.dob =
              "Invalid year. Please enter a valid year (1935-2099)";
          } else {
            const today = new Date();

            // Future date check
            if (dateObj > today) {
              newErrors.dob = "Birth date cannot be in the future";
            }

            // Age check (must be >= 18)
            let age = today.getFullYear() - year;
            const monthDiff = today.getMonth() - (month - 1);
            const dayDiff = today.getDate() - day;

            if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
              age--;
            }

            // if (age < 18) {
            //   newErrors.dob = "Client must be at least 18 years old";
            // }
          }
        }
      }
    }

    // 🔹 Address Validation
    if (!address.street?.trim()) {
      newErrors.address = "Office number is required";
    } else if (address.street.length > 200) {
      newErrors.address = "Office number must not exceed 200 characters";
    }

    if (!address.city?.trim()) {
      newErrors.address = "Premises/City name is required";
    } else if (address.city.length > 200) {
      newErrors.address = "Premises/City name must not exceed 200 characters";
    }

    if (!address.state?.trim()) {
      newErrors.address = "Area/State is required";
    } else if (address.state.length > 100) {
      newErrors.address = "Area/State must not exceed 100 characters";
    }

    if (!address.postalCode?.trim()) {
      newErrors.address = "Postal code is required";
    } else if (!/^\d{4,10}$/.test(address.postalCode)) {
      newErrors.address = "Enter a valid postal code (4-10 digits)";
    }

    // 🔹 Subsidiary
    if (!selectedSubsidary) {
      newErrors.selectedSubsidary = "Subsidiary selection is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ Valid if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    const formattedDate = formatToYYYYMMDD(dob);

    if (!validateForm()) return;

    const formData = {
      client_name: clientName,
      file_number: file_number,
      client_type: clientType,
      clients_company_name: companyName,
      company_type: selectedCompanyType || "",
      family_id: clientType === "family group" ? selectedFamilyId : "",
      contact_list: contactPersons.map((contact) => ({
        contact_id: contact.contactId, // Include contact_id
        contact_name: contact.name,
        contact_email: contact.email,
        phone_number: contact.phone,
        is_primary: contact.isPrimary || false,
      })),
      sub_id: selectedSubsidary?.value || "",
      payment_terms: paymentTerm,
      dob: formattedDate,
      pan_number: pan,
      office_number: address.street,
      landmark: address.city,
      area: address.state,
      pin: address.postalCode,
    };

    try {
      const response = await axiosInstance.put(
        `/api/edit_clients/${client_id}`,
        formData,
      );

      if (response.status === 200) {
        setSnackbarSeverity("success");
        setSnackbarMessage("Client updated successfully!");
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate("/client-management");
        }, 3000);
      } else {
        console.error("Failed to update client:", response.data);
      }
    } catch (error) {
      console.error(
        "Error submitting form:",
        error.response?.data || error.message,
      );

      // Check specifically for PAN number duplicate error
      if (error.response?.data?.error === "PAN number already exists") {
        setErrors((prev) => ({
          ...prev,
          pan: "This PAN number is already registered in the system",
        }));
        setSnackbarSeverity("error");
        setSnackbarMessage("PAN number already exists in the system");
      } else {
        // Show backend error message
        const backendErrorMessage =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "An unexpected error occurred";

        setSnackbarSeverity("error");
        setSnackbarMessage(backendErrorMessage);
      }
      setSnackbarOpen(true);
    }
  };

  // Handle cancel action
  const handleCancel = () => {
    window.history.back();
  };
  const handlePrimaryChange = (index) => {
    if (isPrimaryLocked) return;

    const updatedContacts = contactPersons.map((contact, i) => ({
      ...contact,
      isPrimary: i === index ? true : false,
    }));
    setContactPersons(updatedContacts); // Update the state with the new array
  };

  const handleSubsidiaryChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedSubsidary(null);
      setSelectedSubsidaryId(null);
      return;
    }

    const selectedId = selectedOption.value;
    const selectedLabel = selectedOption.label;

    setSelectedSubsidary(selectedLabel);
    setSelectedSubsidaryId(selectedId);
  };

  // Preselect subsidiary if available
  useEffect(() => {
    if (subsidaries.length > 0 && selectedSubsidaryId) {
      const preselected = subsidaries.find(
        (sub) => sub.value === selectedSubsidaryId,
      );
      if (preselected) {
        setSelectedSubsidary(preselected);
      }
    }
  }, [subsidaries, selectedSubsidaryId]);

  const handleInputChange = (index, field, value) => {
    const updatedContactPersons = [...contactPersons];
    updatedContactPersons[index][field] = value;
    setContactPersons(updatedContactPersons);

    // Clear error when user starts typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`${field}_${index}`]: value.trim()
        ? ""
        : prevErrors?.[`${field}_${index}`],
    }));
  };

  return (
    <div
      className={`table-container client-management-form-page client-management-form-edit ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content form-main-body client-management-form-content">
        <div className="client-management-page-heading">
          <h1 className="form-title">Edit Client Management</h1>
          <p className="client-management-page-subtitle">
            Update client details, address information and contact persons.
          </p>
        </div>
        <div className="client-management-form-card">
          <div className="form-body-client-management client-management-form-body">
            <form className="form-box client-management-form-box">
              <div className="form-body-container client-management-form-sections">
                <section className="client-management-section">
                  <div className="client-management-section-header">
                    <div>
                      <h2 className="client-management-section-title">
                        Basic Information
                      </h2>
                      <p className="client-management-section-description">
                        Update client, company and opening balance details.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Client Name <span className="required">*</span>
                    </label>
                    <div className="form-inputs">
                      <input
                        type="text"
                        className="input-field"
                        placeholder="Enter Client Name"
                        maxLength={100}
                        value={clientName || ""}
                        // onChange={(e) => setClientName(e.target.value)}
                        onChange={(e) => {
                          setClientName(e.target.value);
                          handleInputChanges("clientName", e.target.value);
                        }}
                        required
                      />
                      {errors.clientName && (
                        <p className="error-message">{errors.clientName}</p>
                      )}
                    </div>
                  </div>

                  {/* Company/Firm Name */}
                  <div className="form-group">
                    <label className="form-label">
                      Company/Firm Name <span className="required">*</span>
                    </label>
                    <div className="form-inputs">
                      <input
                        type="text"
                        className="input-field"
                        placeholder="Enter Company/Firm Name"
                        maxLength={150}
                        value={companyName || ""}
                        onChange={(e) => {
                          handleInputChanges("companyName", e.target.value);
                          setCompanyName(e.target.value);
                        }} // Update state directly
                        required
                      />
                      {errors.companyName && (
                        <p className="error-message">{errors.companyName}</p>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">File Number</label>
                    <div className="form-inputs">
                      <input
                        type="text"
                        className="input-field"
                        maxLength={50}
                        placeholder="Enter File Number"
                        value={file_number || ""}
                        onChange={(e) => {
                          handleInputChanges("file_number", e.target.value);
                          setFileNumber(e.target.value);
                        }} // Update state directly
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Company Type<span className="required">*</span>
                    </label>
                    <div className="form-inputs-companyType">
                      <Select
                        className="select-field-companyType"
                        value={
                          selectedCompanyType
                            ? companyTypes.find(
                                (option) =>
                                  option.value === selectedCompanyType,
                              )
                            : null
                        }
                        onChange={(selectedOption) => {
                          const value = selectedOption
                            ? selectedOption.value
                            : "";
                          setSelectedCompanyType(value);
                          handleInputChanges("selectedCompanyType", value); // Clear error on selection
                        }}
                        options={companyTypes}
                        placeholder="Select Company Type"
                        isClearable
                        styles={{
                          menu: (base) => ({
                            ...base,
                            marginTop: 0,
                            borderTop: "none",
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                          }),
                          control: (base) => ({
                            ...base,
                            marginBottom: 0,
                          }),
                        }}
                      />
                    </div>
                    {errors.selectedCompanyType && (
                      <p className="error-message">
                        {errors.selectedCompanyType}
                      </p>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Client Type <span className="required">*</span>
                    </label>
                    <div className="form-inputs">
                      <div className="radio-group">
                        <label className="radio-label">
                          <input
                            type="radio"
                            name="client_type"
                            checked={clientType === "individual"}
                            onChange={() => {
                              setClientType("individual");
                            }}
                          />
                          <span className="radio-text">Individual</span>
                        </label>
                        <label className="radio-label">
                          <input
                            type="radio"
                            name="client_type"
                            checked={clientType === "family group"}
                            onChange={() => {
                              setClientType("family group");
                            }}
                          />
                          <span className="radio-text">Family Group</span>
                        </label>
                      </div>
                      {errors.clientType && (
                        <p className="error-message">{errors.clientType}</p>
                      )}
                    </div>
                  </div>

                  {clientType === "family group" && (
                    <div className="form-group">
                      <label className="form-label">Select Family Group</label>
                      <div className="form-inputs form-family-row">
                        <Select
                          className="select-field"
                          value={
                            selectedFamilyId
                              ? familyGroups
                                  .map((family) => ({
                                    value: family.family_id,
                                    label: family.family_name,
                                  }))
                                  .find(
                                    (option) =>
                                      option.value === selectedFamilyId,
                                  ) || null
                              : null
                          }
                          onChange={(selectedOption) => {
                            const nextFamilyId = selectedOption?.value || "";
                            setSelectedFamilyId(nextFamilyId);

                            if (!nextFamilyId) return;

                            const selectedFamily = familyGroups.find(
                              (family) => family.family_id === nextFamilyId,
                            );
                            mapFamilyContactToPrimary(selectedFamily);
                          }}
                          options={familyGroups.map((family) => ({
                            value: family.family_id,
                            label: family.family_name,
                          }))}
                          placeholder={
                            familyGroupsLoading
                              ? "Loading family groups..."
                              : "Select Family Group"
                          }
                          isClearable
                          isLoading={familyGroupsLoading}
                          menuPortalTarget={menuPortalTarget}
                          menuPosition="fixed"
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                        <button
                          type="button"
                          className="family-plus-btn"
                          aria-label="Add family group"
                          onClick={openCreateFamilyModal}
                        >
                          +
                        </button>
                        {familyGroupsError && (
                          <p className="error-message">{familyGroupsError}</p>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="form-group">
                    <label className="form-label">
                      Opening Balance <span className="required">*</span>
                    </label>

                    {/* Uneditable input field for balance type */}
                    <input
                      type="text"
                      className="input-field input-openbalance-info"
                      placeholder="Credit/Debit"
                      value={selectedOptionBalance}
                      readOnly={true} // Makes the input field uneditable
                    />

                    {/* Uneditable input field for opening balance amount */}
                    <input
                      type="number"
                      className="input-field input-openbalance-info"
                      placeholder="Enter Amount"
                      value={openingAmount}
                      readOnly={true} // Makes the input field uneditable
                    />
                  </div>
                </section>

                <section className="client-management-section">
                  <div className="client-management-section-header">
                    <div>
                      <h2 className="client-management-section-title">
                        Client Info <span className="required">*</span>
                      </h2>
                      <p className="client-management-section-description">
                        Keep incorporation or birth details and PAN information
                        up to date.
                      </p>
                    </div>
                  </div>

                  {/* Client Info: DOB and PAN */}
                  <div className="form-group">
                    <label className="form-label">
                      Client Info<span className="required">*</span>
                    </label>
                    <div className="form-inputs">
                      <div>
                        <input
                          type="text"
                          className="input-field input-client-date birth-date"
                          placeholder="Date of Incorpoation / Date of Birth (DD-MM-YYYY)"
                          value={dob}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d-]/g, "");

                            // prevent more than 10 char
                            value = value.slice(0, 10);

                            // auto restrict multiple hyphens
                            const parts = value.split("-");
                            if (parts.length > 3) return;

                            setDob(value);
                            setErrors((prev) => ({ ...prev, dob: "" }));
                          }}
                          maxLength={10}
                          required
                        />
                        {errors.dob && (
                          <p className="error-message">{errors.dob}</p>
                        )}
                        <div>
                          <small className="date-format-hint">
                            Date of Incorpoation / Date of Birth
                          </small>
                        </div>
                      </div>

                      <div>
                        <input
                          type="text"
                          className={`input-field input-client-info ${
                            errors.pan ? "error-input" : ""
                          }`}
                          placeholder="Enter PAN Number"
                          maxLength={10}
                          value={pan}
                          style={{ width: "100%" }}
                          onChange={(e) => {
                            setPan(e.target.value);
                            // Clear error when user starts typing
                            setErrors((prev) => ({ ...prev, pan: "" }));
                          }}
                          required
                        />
                        {errors.pan && (
                          <p className="error-message">{errors.pan}</p>
                        )}
                        <div>
                          <small className="date-format-hint">
                            Pan Card No.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="client-management-section">
                  <div className="client-management-section-header">
                    <div>
                      <h2 className="client-management-section-title">
                        Client Address <span className="required">*</span>
                      </h2>
                      <p className="client-management-section-description">
                        Arrange the full office address in a cleaner layout.
                      </p>
                    </div>
                  </div>

                  <div className="form-group client-management-contact-section-group">
                    <label className="form-label">
                      Client Address<span className="required">*</span>
                    </label>
                    <div className="form-inputs">
                      {/* First row of inputs */}
                      <div className="address-row" style={{ width: "24%" }}>
                        <input
                          type="text"
                          className="input-field input-client-info"
                          maxLength={100}
                          placeholder="Enter office number"
                          value={address.street}
                          onChange={(e) =>
                            handleAddressChange("street", e.target.value)
                          }
                          required
                        />
                        <div>
                          <small className="date-format-hint">
                            Office Number
                          </small>
                        </div>
                      </div>
                      <div className="address-row">
                        <input
                          type="text"
                          className="input-field input-premise-info"
                          placeholder="Name of premises"
                          maxLength={100}
                          value={address.city}
                          onChange={(e) =>
                            handleAddressChange("city", e.target.value)
                          }
                          required
                        />
                        <div>
                          <small className="date-format-hint">
                            Name of premises
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="client-management-section client-management-section-last">
                  <div className="form-group">
                    <label className="form-label"></label>
                    <div
                      className="form-inputs-clinetAdress"
                      style={{ gap: "24px", width: "37%" }}
                    >
                      <div
                        className="address-rowss"
                        id="vishal1"
                        style={{ width: "50%" }}
                      >
                        <input
                          type="text"
                          className="input-field input-adress-info"
                          placeholder="Area"
                          value={address.state}
                          maxLength={100}
                          onChange={(e) =>
                            handleAddressChange("state", e.target.value)
                          }
                          required
                        />
                        <div>
                          <small className="date-format-hint">Area</small>
                        </div>
                      </div>
                      <div
                        className="address-rowss"
                        id="vishal2"
                        style={{ width: "50%" }}
                      >
                        <input
                          type="number"
                          className="input-field input input-adress-info"
                          placeholder="Postal code"
                          value={address.postalCode}
                          onChange={(e) =>
                            handleAddressChange("postalCode", e.target.value)
                          }
                          required
                        />
                        <div>
                          <small className="date-format-hint">
                            Postal code
                          </small>
                        </div>
                      </div>
                    </div>
                    {errors.address && (
                      <p className="error-message">{errors.address}</p>
                    )}{" "}
                    {/* Show PAN error */}
                  </div>

                  <div className="client-management-section-header">
                    <div>
                      <h2 className="client-management-section-title">
                        Contact Person Details{" "}
                        <span className="required">*</span>
                      </h2>
                      <p className="client-management-section-description">
                        Manage primary and additional contact persons.
                      </p>
                    </div>
                  </div>

                  <div className="form-group client-management-contact-section-group">
                    <label className="form-label">
                      Contact Person Details <span className="required">*</span>
                    </label>

                    <div className="form-inputs">
                      {contactPersons.map((contact, index) => (
                        <div key={index} className="contact-person-fields">
                          <div className="contact-detail">
                            <input
                              type="text"
                              className="input-field"
                              maxLength={100}
                              placeholder="Enter Contact Person Name"
                              value={contact.name}
                              readOnly={isPrimaryLocked && index === 0}
                              onChange={(e) =>
                                handleInputChange(index, "name", e.target.value)
                              }
                              required
                            />
                            {errors[`name_${index}`] && (
                              <span className="error-message">
                                {errors[`name_${index}`]}
                              </span>
                            )}
                          </div>

                          <div className="contact-detail">
                            <input
                              type="email"
                              className="input-field"
                              maxLength={100}
                              placeholder="Enter Contact Person Email"
                              value={contact.email}
                              readOnly={isPrimaryLocked && index === 0}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "email",
                                  e.target.value,
                                )
                              }
                              required
                            />
                            {errors[`email_${index}`] && (
                              <span className="error-message">
                                {errors[`email_${index}`]}
                              </span>
                            )}
                          </div>

                          <div className="contact-detail">
                            <input
                              type="number"
                              className="input-field"
                              maxLength={10}
                              placeholder="Enter Phone Number"
                              value={contact.phone}
                              readOnly={isPrimaryLocked && index === 0}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "phone",
                                  e.target.value,
                                )
                              }
                              required
                            />
                            {errors[`phone_${index}`] && (
                              <span className="error-message">
                                {errors[`phone_${index}`]}
                              </span>
                            )}
                          </div>

                          <div className="contact-detail primary-contact">
                            <label className="radio-label">
                              Set as Primary Contact?
                            </label>
                            <div className="radio-options">
                              <label className="radio-option">
                                <input
                                  type="radio"
                                  name="primaryContact"
                                  checked={contact.isPrimary ?? index === 0} // Default first contact as primary
                                  disabled={isPrimaryLocked}
                                  onChange={() => handlePrimaryChange(index)}
                                />
                              </label>
                            </div>
                          </div>

                          <div className="button-field">
                            {contactPersons.length > 1 && (
                              <button
                                type="button"
                                className="remove-contact-btn"
                                onClick={() => handleRemoveContactPerson(index)}
                              >
                                <span>×</span>
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      <div className="add-contact-btn-wrapper">
                        <button
                          type="button"
                          className="add-contact-btn"
                          onClick={handleAddContactPerson}
                        >
                          <span>+</span>
                          <span className="add-text">
                            Add More Contact Person
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="client-management-section-header">
                    <div>
                      <h2 className="client-management-section-title">
                        Billing & Terms
                      </h2>
                      <p className="client-management-section-description">
                        Keep billing company and payment terms aligned with the
                        client record.
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Customer Billing Company
                      <span className="required">*</span> <br />
                      (Sub Company)
                    </label>
                    <div className="form-inputs">
                      <Select
                        className={`select-field ${
                          errors.selectedSubsidary ? "input-error" : ""
                        }`}
                        value={
                          selectedSubsidary
                            ? subsidaries.find(
                                (sub) => sub.value === selectedSubsidary.value,
                              ) || null
                            : null
                        }
                        onChange={(selectedOption) => {
                          if (selectedOption?.isCreateNew) {
                            setIsSubsidiaryModalOpen(true); // open modal
                            return;
                          }
                          setSelectedSubsidary(selectedOption);
                          setErrors((prev) => ({
                            ...prev,
                            selectedSubsidary: selectedOption
                              ? ""
                              : prev?.selectedSubsidary,
                          }));
                        }}
                        options={[
                          ...subsidaries.map((sub) => ({
                            value: sub.value,
                            label: `${sub.label} (${sub.tag_name})`,
                          })),
                        ]}
                        placeholder="Select Type Of Client"
                        isClearable
                      />
                      <button
                        type="button"
                        className="family-plus-btn"
                        aria-label="Add family group"
                        onClick={() => setIsSubsidiaryModalOpen(true)}
                      >
                        +
                      </button>
                      {errors.selectedSubsidary && (
                        <span className="error-message">
                          {errors.selectedSubsidary}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Payment Term */}
                  <div className="form-group">
                    <label className="form-label">
                      Payment Terms<span className="required">*</span>
                    </label>
                    <div className="form-inputs">
                      <input
                        type="text"
                        className="input-field"
                        placeholder="Enter Payment Terms"
                        value={paymentTerm}
                        onChange={(e) => setPaymentTerm(e.target.value)}
                        required
                      />
                      <p className="form-label">Days</p>
                      {errors.paymentTerm && (
                        <p className="error-message">{errors.paymentTerm}</p>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </form>
          </div>
          <div className="form-footer client-management-form-footer">
            <div className="button-group">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={handleCancel}
              >
                CANCEL
              </button>
              <button
                type="submit"
                className="btn btn-save"
                onClick={handleSubmit}
              >
                SAVE
              </button>
            </div>
          </div>
        </div>
      </div>
      {isCreateFamilyModalOpen &&
        familyModalPortalTarget &&
        createPortal(
          <div className="invoice-family-modal-root">
            <div className="invoice-family-modal-overlay" />
            <div className="invoice-family-modal-wrapper">
              <div className="invoice-family-modal-content">
                <div className="invoice-family-modal-header">
                  <div>
                    <h2 className="invoice-family-modal-title">
                      Create New Family Group
                    </h2>
                    <p className="invoice-family-modal-subtitle">
                      Add a family group to associate with this client.
                    </p>
                  </div>
                  <button
                    type="button"
                    className="invoice-family-modal-close"
                    onClick={closeCreateFamilyModal}
                    aria-label="Close family group modal"
                  >
                    <X size={18} />
                  </button>
                </div>
                <div className="invoice-family-modal-body">
                  <div className="invoice-family-form-stack">
                    <div className="client-form-group">
                      <label className="client-form-label">
                        Family Name <span className="client-required">*</span>
                      </label>
                      <input
                        ref={createFamilyFirstInputRef}
                        type="text"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.family_name
                            ? "client-input-error"
                            : ""
                        }`}
                        autoFocus
                        placeholder="Enter Family Name"
                        value={createFamilyForm.family_name}
                        onChange={(e) => {
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            family_name: e.target.value,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            family_name: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.family_name && (
                        <p className="client-error-message">
                          {createFamilyErrors.family_name}
                        </p>
                      )}
                    </div>

                    <div className="client-form-group">
                      <label className="client-form-label">
                        Contact Name <span className="client-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.contact_name
                            ? "client-input-error"
                            : ""
                        }`}
                        placeholder="Enter Contact Name"
                        value={createFamilyForm.contact_name}
                        onChange={(e) => {
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            contact_name: e.target.value,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            contact_name: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.contact_name && (
                        <p className="client-error-message">
                          {createFamilyErrors.contact_name}
                        </p>
                      )}
                    </div>

                    <div className="client-form-group">
                      <label className="client-form-label">
                        Phone Number <span className="client-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.phone_number
                            ? "client-input-error"
                            : ""
                        }`}
                        placeholder="Enter Phone Number"
                        value={createFamilyForm.phone_number}
                        maxLength={10}
                        onChange={(e) => {
                          const phoneValue = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 10);
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            phone_number: phoneValue,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            phone_number: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.phone_number && (
                        <p className="client-error-message">
                          {createFamilyErrors.phone_number}
                        </p>
                      )}
                    </div>

                    <div className="client-form-group">
                      <label className="client-form-label">
                        Email Id <span className="client-required">*</span>
                      </label>
                      <input
                        type="email"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.email ? "client-input-error" : ""
                        }`}
                        placeholder="Enter Email Id"
                        value={createFamilyForm.email}
                        onChange={(e) => {
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            email: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.email && (
                        <p className="client-error-message">
                          {createFamilyErrors.email}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="invoice-family-modal-buttons">
                  <button
                    type="button"
                    className="invoice-client-secondary-btn"
                    onClick={closeCreateFamilyModal}
                    disabled={isCreatingFamily}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="invoice-client-primary-btn"
                    onClick={handleCreateFamily}
                    disabled={isCreatingFamily}
                  >
                    {isCreatingFamily ? "Creating..." : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </div>,
          familyModalPortalTarget,
        )}
      <SubsidiaryModal
        isOpen={isSubsidiaryModalOpen}
        onClose={() => setIsSubsidiaryModalOpen(false)}
        onSuccess={handleSubsidiaryCreated}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(40px)", marginLeft: "15px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
